import { BASE_URL, API_ENDPOINT_USER_LIST } from "../../../utils/constants";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

const getUsersList = createAsyncThunk("user/userlist", async (thunkAPI) => {
    try {
        const res = await axiosInstance.get(`${BASE_URL}${API_ENDPOINT_USER_LIST}`);
        const responseData = await res.data;
        return responseData;
    } catch (error) {
        return thunkAPI?.rejectWithValue(error?.response?.data);
    }
})

export { getUsersList };